import IframeCloseButton from "components/wrapper_v2/IframeCloseButton";
import { useTranslation } from "react-i18next";
import Loading from "../../assets/images/loader.gif";

const FallBackLoader = ({ loaderMessage = false }) => {
  const { i18n } = useTranslation();

  const getLoadingText = () => {
    if (loaderMessage) {
      return i18n?.t("common.LOGIN_LOADING");
    } else {
      return i18n?.t("common.LOADING");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <IframeCloseButton />
        <img
          src={Loading}
          style={{ height: "12vh", width: "12vh" }}
          className="noki-loader"
          alt="Loading..."
        />
        <br />
        {getLoadingText()}...
      </div>
    </>
  );
};

export default FallBackLoader;
